import React, { Suspense, useState } from "react";
import styled from "styled-components";
import images from "../../../../../images/Featured Projects/Sarulla/images.webp";
import images2 from "../../../../../images/Featured Projects/Sarulla/images2.webp";
import images3 from "../../../../../images/Featured Projects/Sarulla/images3.webp";
import images4 from "../../../../../images/Featured Projects/Sarulla/images4.webp";
import img from "../../../../../images/Featured Projects/Top.webp";
import { Helmet } from "react-helmet-async";

const Navbar = React.lazy(() => import("../Navbar"));
const Sidebar = React.lazy(() => import("../Navbar/Sidebar"));

export const AllProjectContainers = styled.div`
  background: #0f0f0f;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 100vh;
`;

export const ProjectContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 200px;
  background-image: url(${img});
  padding-top: 4rem;
`;

export const Titles = styled.h1`
  color: #fff;
  padding-top: 3.5rem;
  text-align: center;
`;

export const ProjectText = styled.div`
  max-width: 500px;
  padding-top: 7rem;

  @media (max-width: 575.98px) {
    padding-top: 2rem;
  }
`;

export const SubTitle = styled.h2`
  color: #e85508;
  padding-bottom: 1rem;
  text-align: center;
`;

export const ListDesc = styled.p`
  color: #fff;
  padding-bottom: 0.5rem;
  text-align: center;
  font-size: 16px;
  letter-spacing: 0.03em;
  line-height: 160%;
`;

export const Text = styled.p`
  color: #e2e2e2;
  max-width: 400px;
  padding-bottom: 0.5rem;
  font-size: 16px;
  letter-spacing: 0.03em;
  line-height: 160%;
  text-align: center;

  @media (max-width: 575.98px) {
    max-width: 350px;
    text-align: left;
  }
`;

export const Bolder = styled.p`
  font-weight: 600;
  color: #fff;
  padding-top: 0.5rem;
  font-size: 16px;
  letter-spacing: 0.03em;
  line-height: 160%;
`;

export const ProjectIMG = styled.div`
  padding-top: 1rem;
`;

export const IMG = styled.img`
  height:100%
  fit-content: cover;
  min-width: 330px;

  @media (max-width: 575.98px) {
    max-width: 450px;
    max-height: 250px;
  }
`;

const Sarulla = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Helmet>
        <title>Featured Project | Sarulla Oil Limited</title>
        <meta
          name="description"
          content="The featured project of Sarulla Oil Limited from PT ICONIQ MULTI DIMENSI - ICONIQ Interior"
        />
        <link
          rel="canonical"
          href="https://iconiq-interior.co.id/project/featured-project/sarulla"
        />
      </Helmet>
      <AllProjectContainers>
        <Suspense fallback={<div>Loading...</div>}>
          <Sidebar isOpen={isOpen} toggle={toggle} />
        </Suspense>
        <Suspense fallback={<div>Loading...</div>}>
          <Navbar toggle={toggle} />
        </Suspense>
        <TitleContainer>
          <Titles>SARULLA OIL LIMITED</Titles>
        </TitleContainer>
        <ProjectContainer>
          <ProjectText>
            <SubTitle>Project Details :</SubTitle>
            <ListDesc>
              <Text>
                <Bolder>Project :</Bolder> Sarulla Oil Limited
              </Text>
              <Text>
                <Bolder>Business Core :</Bolder> Oil Company
              </Text>
              <Text>
                <Bolder>Area :</Bolder> 750 sqm
              </Text>
              <Text>
                <Bolder>Location :</Bolder> Energy Building 7th Floor, SCBD
              </Text>
              <Text>
                <Bolder>Concept :</Bolder> Minimalist design with wooden accent
                with optimization of existing furniture
              </Text>
            </ListDesc>
          </ProjectText>
          <ProjectIMG>
            <IMG
              src={images}
              alt="Iconiq Interior featured project Sarulla Oil Limited"
              title="Featured Project | Sarulla Oil Limited"
              loading="eager"
            />
          </ProjectIMG>
          <ProjectIMG>
            <IMG
              src={images2}
              alt="Iconiq Interior featured project Sarulla Oil Limited"
              title="Featured Project | Sarulla Oil Limited"
              loading="lazy"
            />
          </ProjectIMG>
          <ProjectIMG>
            <IMG
              src={images3}
              alt="Iconiq Interior featured project Sarulla Oil Limited"
              title="Featured Project | Sarulla Oil Limited"
              loading="lazy"
            />
          </ProjectIMG>
          <ProjectIMG>
            <IMG
              src={images4}
              alt="Iconiq Interior featured project Sarulla Oil Limited"
              title="Featured Project | Sarulla Oil Limited"
              loading="lazy"
            />
          </ProjectIMG>
        </ProjectContainer>
      </AllProjectContainers>
    </>
  );
};

export default Sarulla;
